import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { Region } from "./regions"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export const formatTimeAgo = (timestamp: number): string => {
  const now = Date.now()
  const diff = now - timestamp
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor(diff / (1000 * 60 * 60))
  const minutes = Math.floor(diff / (1000 * 60))

  if (days > 0) return `vor ${days} Tag${days > 1 ? 'en' : ''}`
  if (hours > 0) return `vor ${hours} Stunde${hours > 1 ? 'n' : ''}`
  if (minutes > 0) return `vor ${minutes} Minute${minutes > 1 ? 'n' : ''}`
  return 'Gerade eben'
}


export const getRegionOutOfGameId = (gameId: string): Region => {
  // Extract the region from the gameId
  // Example gameId: "EUW1_1234567890"
  const parts = gameId.split('_')
  if (parts.length < 2) return Region.EUW // Default to EUW if format is unexpected
  
  const region = parts[0]
  switch (region.toUpperCase()) {
    case "BR1":
    case "BRA":
    case "BRAZIL":
      return Region.BR;
    case "EUN1":
    case "EUNE":
    case "EUN":
      return Region.EUNE;
    case "EUW1":
    case "EUW":
      return Region.EUW;
    case "JP1":
    case "JP":
      return Region.JP;
    case "KR":
    case "KR1":
      return Region.KR;
    case "LA1":
    case "LAN":
      return Region.LAN;
    case "LA2":
    case "LAS":
      return Region.LAS;
    case "NA1":
    case "NA":
      return Region.NA;
    case "OC1":
    case "OCE":
      return Region.OCE;
    case "TR1":
    case "TR":
      return Region.TR;
    case "RU":
    case "RU1":
      return Region.RU;
    default:
      return region as Region; // Default fallback
  }
}

export const VOD_URL_BASE = "https://vod.noway.gg/vod"
export const buildVodUrl = (vodId: string, offset: number = 0): string => {
  return `${VOD_URL_BASE}/${vodId}?offset=${offset}`
}